<template>
  <div class="article-box">
    <h5 class="article_title">{{ $t('pc.footer.company_qualification') }}</h5>
    <hr>
    <div class="article_content" v-html="data">
      <!--<h5>【公司营业执照】</h5>
      <p>
        <img width="100%" src="../assets/img/7047b84a3a514b3554e89d66755efca2.jpg" title="最新营业执照.jpg" alt="最新营业执照.jpg"></p>
      <h5>【荣获证书及奖牌】</h5>
      <p>
        <img width="100%" src="../assets/img/0114e6758b64347af69780bddf26cd80.jpg" title="证书7.jpg" alt="证书7.jpg">
      </p>
      <h5>【水滴信用证书】</h5>
      <p>
        <img src="../assets/img/ec4f7d6c6c6e36a1d6e7fbced77badc8.jpg" title="5_6307663278134788291.jpg" alt="5_6307663278134788291.jpg" width="100%">
      </p>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "helpqualification",
    data(){
      return{
        data:''
      }
    },
    methods:{
      getData(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'protocol',
              'type': 8,
            }
          })  .then(res => {
          let resData = res.data;
          if (res.data.code == 1) {
            that.data = resData.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
      }
    },
    mounted() {
      this.getData();
    }
  }
</script>

<style scoped>
  .article_title {
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>>img{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpqualification.vue